'use client';

import { MediaShareButton } from '@/ui/buttons/MediaShareButton';
import { mapToRelativeTime } from '@vimond/utils';
import { useTranslation } from 'react-i18next';
import { getEnvVar } from '@vimond/utils/env';

type Props = {
  contentId: string;
  title: string;
  description?: string;
  publishTime?: string;
};

export const VideoInfoDetailsCard = ({
  contentId,
  description,
  publishTime,
  title,
}: Props) => {
  const { i18n, t } = useTranslation();
  const { language } = i18n;

  return (
    <div className="w-full mt-6 px-5 py-3 animate-fade-in bg-background shadow-sm lg:rounded-xl">
      <h1 className="font-semibold text-xl sm:pt-2 sm:text-2xl lg:text-3xl">
        {title}
      </h1>
      <div className="flex justify-between items-end">
        {getEnvVar('NEXT_PUBLIC_SHOW_PUBLISH_DATE') === 'true' &&
          publishTime && (
            <div className="flex items-center gap-4 text-shadow text-sm opacity-75">
              <span>{mapToRelativeTime(publishTime, t, language)}</span>
            </div>
          )}
        <MediaShareButton
          className="flex w-20 h-7 mt-1 justify-evenly items-center rounded-lg border border-background-border outline-none shadow-sm shadow-slate-500 text-sm opacity-80 sm:font-semibold sm:w-24 sm:h-8 sm:px-2 hover:bg-background-border"
          iconClassName="w-4 h-4 sm:w-5 sm:h-5 opacity-95"
          contentId={contentId}
          contentTitle={title}
          buttonText="Share"
        />
      </div>

      <div className="mt-3 border-t border-background-border opacity-75">
        {description && (
          <p className="my-2 text-sm leading-6 sm:text-base font-medium text-text-input text-pretty">
            {description}
          </p>
        )}
      </div>
    </div>
  );
};
